<div class="w-full px-64 py-10 m-2 flex flex-col items-center pad-4">
    <i class="pi pi-times-circle text-primary text-[12rem]"></i>
    <h1 class="text-3xl font-bold text-center">Access is forbidden</h1>
    <p class="text-lg text-center">You don't have the required role to access this page</p>
</div>